import { render } from "./Dashboard.vue?vue&type=template&id=d79beb4e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=d79beb4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d79beb4e"],['__file',"src/components/dashboard/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d79beb4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d79beb4e', __exports__)) {
    api.reload('d79beb4e', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=d79beb4e&scoped=true", () => {
    api.rerender('d79beb4e', render)
  })

}


export default __exports__